import { createReducer, MetaReducer, on } from '@ngrx/store';
import { IFlight } from '../../../../model/flights';
import FlightsActions from './flights.action-types';

export const flightsFeatureKey = 'flights';

export interface FlightsState {
    flights: IFlight[];
}

export const initialFlightsState: FlightsState = {
    flights: []
};

export const metaReducers: MetaReducer<FlightsState>[] = [];

export const flightsReducer = createReducer(
    initialFlightsState,

    on(FlightsActions.loadFlights, (state, action) => {
        return {
            flights: action.flights
        };
    })
);
